import { Grid, IconButton, Box } from '@mui/material';
import MuiFormControl from '@mui/material/FormControl';
import React, { useCallback } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import Button from '../../common/Button.component';
import { DynamicControl } from '../DynamicControl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Divider from './Divider.component';

import PropTypes from 'prop-types';

const AddMoreFormFields = ({
  name,
  required,
  options,
  buttonLabel = 'Add new contact',
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const {
    field: { onChange, value },
  } = useController({
    name: name,
    control: control,
    rules: { required },
  });

  const addFields = useCallback(() => {
    let newfield = {};
    onChange(value ? [...value, newfield] : [newfield]);
  }, [value, onChange]);

  const handleFormChange = (index, event, data) => {
    const newFieldValue =
      event.target.value !== undefined && event.target.value !== ''
        ? event.target.value
        : (data ?? null);
    const dataValues = value.map((item, i) =>
      i === index ? { ...item, [event.target.name]: newFieldValue } : item
    );
    onChange(dataValues);
  };

  const removeFields = (index) => {
    const confirmDelete = window.confirm(
      'Are you sure you want to remove this contact?'
    );
    if (!confirmDelete) return;

    let data = [...value];
    data.splice(index, 1);
    onChange(data);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MuiFormControl sx={{ width: '100%' }}>
          {value &&
            value?.map((input, index) => (
              <Grid container spacing={1} alignItems='center' key={index}>
                <Grid item xs={12} md={11}>
                  <Grid container spacing={1}>
                    {options.map(({ xs, sm, md, ...d }, i) => {
                      const fieldError = errors?.[name]?.[index]?.[d.name]?.message;

                      return (
                        <Grid item xs={xs || 12} sm={sm || 12} md={md || sm || 12} key={i}>
                          <DynamicControl
                            {...d}
                            value={input?.[d.name] ?? null}
                            onChange={(event, data) =>
                              event?.target?.name
                                ? handleFormChange(index, event, data)
                                : handleFormChange(
                                  index,
                                  { target: { name: d.name } },
                                  data
                                )
                            }
                          />

                          {fieldError && (
                            <Box
                              mt={0.5}
                              sx={{
                                color: 'error.main',
                                fontSize: '0.75rem',
                              }}
                            >
                              {fieldError}
                            </Box>
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={1}
                  sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'center' } }}
                >
                  <IconButton onClick={() => removeFields(index)}>
                    <DeleteIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
            ))}
          {errors?.[name]?.message && (
            <Box
              mt={1}
              sx={{
                color: 'error.main',
                fontSize: '0.75rem',
              }}
            >
              {errors[name].message}
            </Box>
          )}
        </MuiFormControl>
      </Grid>

      <Grid item xs={12}>
        <Button
          onClick={() => addFields()}
          variant='outlined'
          startIcon={<AddIcon />}
        >
          {buttonLabel}
        </Button>
      </Grid>
    </Grid>
  );
};

export default AddMoreFormFields;

AddMoreFormFields.propTypes = {
  name: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.array,
  buttonLabel: PropTypes.string,
};